import { noop } from 'lodash';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { PaymentCard, Preauthorization } from '@mews-commander/types';
import { Typography, DropdownItem, DropdownItemProps } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { SpacedDash } from '@mews-commander/ui';
import { createCardLabel } from '@mews-commander/legacy-entities/src/ducks/paymentCards';

interface PreauthorizationOptionProps {
    handlePreauthorizationClick: (preauthorizationId: string) => void;
    preauthorization: Preauthorization;
    paymentCard: PaymentCard;
    onClick(): void;
}

const renderPreauthorizationText = (paymentCard: PaymentCard, value: number, currency: string) => (
    <Typography textStyle="bodyMediumStrong" as="div">
        {createCardLabel(paymentCard)}
        {SpacedDash}
        <LocalizedText textKey={TextKey.Preauthorization} />
        {UnicodeEntity.NoBreakSpace}
        <LocalizedCurrencyValue value={{ value, currency }} />
    </Typography>
);

export const PreauthorizationOption: React.FC<PreauthorizationOptionProps> = ({
    handlePreauthorizationClick,
    paymentCard,
    preauthorization,
    onClick = noop,
}) => {
    const { amount, currency, id } = preauthorization;
    const handleClick: DropdownItemProps['onClick'] = (e, value) => {
        if (typeof value === 'string') {
            handlePreauthorizationClick(value);
        }
        onClick();
    };

    return (
        <DropdownItem
            value={id}
            onClick={handleClick}
            label={renderPreauthorizationText(paymentCard, amount, currency)}
            data-test-id={DataTestId.BillingChargePreauthorizationDropdownOption}
        />
    );
};
